<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'BoardContainer'
}
</script>

<style></style>
